/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_VestingTemplate_CreateVestingTemplateDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_CreateVestingTemplateDto';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_UpdateVestingTemplateDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_UpdateVestingTemplateDto';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VestingTemplateLegacyService {

    /**
     * @param companyId 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateLegacyValidateCreateVestingTemplate(
companyId: string,
requestBody?: Wealthlane_AwardService_Dtos_VestingTemplate_CreateVestingTemplateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template-legacy/validate-create-vesting-template/{companyId}',
            path: {
                'companyId': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateLegacyValidateHybridTypeCreateVestingTemplate(
requestBody?: Wealthlane_AwardService_Dtos_VestingTemplate_CreateVestingTemplateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template-legacy/validate-hybrid-type-create-vesting-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateLegacyValidateStepTypeCreateVestingTemplate(
requestBody?: Wealthlane_AwardService_Dtos_VestingTemplate_CreateVestingTemplateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template-legacy/validate-step-type-create-vesting-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateLegacyValidateCustomTypeCreateVestingTemplate(
requestBody?: Wealthlane_AwardService_Dtos_VestingTemplate_CreateVestingTemplateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_ValidateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template-legacy/validate-custom-type-create-vesting-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateLegacyValidateStepTypeUpdateVestingTemplate(
requestBody?: Wealthlane_AwardService_Dtos_VestingTemplate_UpdateVestingTemplateDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template-legacy/validate-step-type-update-vesting-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateLegacyValidateHybridTypeUpdateVestingTemplate(
requestBody?: Wealthlane_AwardService_Dtos_VestingTemplate_UpdateVestingTemplateDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template-legacy/validate-hybrid-type-update-vesting-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
